import { useSelector } from 'react-redux'
import { useIntl } from 'react-intl'
import { PROMPT_PREQUAL } from '../../../../../../constants/messages'
import { selectContactEmail, selectContactFirstName } from '../../../../../../store/selectors/contact'
import Email from '../../../../../shared/Email'

export const PrequalContactEmailLink = () => {
  const intl = useIntl()
  const name = useSelector(selectContactFirstName)
  const email = useSelector(selectContactEmail)

  return (
    <Email
      text={intl.formatMessage(PROMPT_PREQUAL.email_link, { name })}
      value={email}
      data-qa='PrequalContactEmailLink'
    />
  )
}
